import { Typography } from '@mui/material';
import { Grid, Button, FormControlLabel, Checkbox, Slider, Box, Divider, Skeleton, Switch } from '@mui/material';
import MainCard from 'components/MainCard';

import * as Yup from 'yup';
import { Formik } from 'formik';

import { useSelector, useDispatch } from 'react-redux';
import * as FirestoreDataService from './../../services/FirestoreDataService';
import { showAppAlert } from 'store/reducers/appreducer';
import { resolvePartnerModifySettingsAllowed } from 'utils/partnerUiCapabilities';
import { useEffect, useState } from 'react';

import { setDoc, doc } from 'firebase/firestore';
import { db } from '../../services/firebase';
import OfflineDialog from 'components/OfflineDialog';

const INITIAL_VALUES = {
  fallDownAlert: {
    enable: false,
    always_on: false,
    dial: false,
    sensitive_level: 0,
    submit: null
  }
};

const FallDownAlertSettingsPage = () => {
  const { selectedDevice, appUser } = useSelector((state) => state.appreducer);
  const [fallDownAlertSettings, setFallDownAlertSettings] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    // console.log('SelectedDevice ---->', selectedDevice);
    (async () => {
      const status = await FirestoreDataService.getDeviceStatus(selectedDevice);

      if (status.exists()) {
        // console.log('statusRef data is - - -', status.data());
        const last_online_time = status.data()?.last_online_time;
        const offlineThreshold = 5 * 60 * 1000; // 5 minutes;
        const currentTime = Date.now();
        const deviceStatus = currentTime - last_online_time < offlineThreshold ? 'online' : 'offline';

        // console.log('device online status is ->', deviceStatus);

        if (deviceStatus === 'offline') {
          setIsDialogOpen(true);
        }
      }
    })();
  }, []);

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const marks = [
    {
      value: 0,
      label: '0'
    },
    {
      value: 1,
      label: '1'
    },
    {
      value: 2,
      label: '2'
    },
    {
      value: 3,
      label: '3'
    },
    {
      value: 4,
      label: '4'
    },
    {
      value: 5,
      label: '5'
    },
    {
      value: 6,
      label: '6'
    },
    {
      value: 7,
      label: '7'
    },
    {
      value: 8,
      label: '8'
    },
    {
      value: 9,
      label: '9'
    }
  ];

  useEffect(() => {
    // console.log(selectedDevice)
    if (!selectedDevice) return;
    setLoading(true);
    (async () => {
      await FirestoreDataService.getDeviceSettings(selectedDevice)
        .then((documentSnap) => {
          if (documentSnap.exists()) {
            let fallDownAlertObject = documentSnap.data().falldown_alert;
            // console.log('Fetched:-', fallDownAlertObject);
            setFallDownAlertSettings(fallDownAlertObject);
          }
        })
        .catch((e) => {
          const msg = 'Failed to get fall down alert settings!';
          dispatch(showAppAlert({ show: true, alertType: 'error', alertMessage: msg }));
          console.info(msg, e);
        })
        .finally(() => {
          setLoading(false);
        });
    })();
  }, [selectedDevice]);

  return (
    <Grid item xs={12} sm={12} md={8} lg={6}>
      <MainCard contentSX={{ p: 2.25 }} style={{ height: '100%' }}>
        <Typography variant="h6" color="textSecondary">
          Fall Down Alert Settings
        </Typography>
        {loading ? (
          <>
            <Skeleton variant="rectangular" animation="wave" height={230} />
          </>
        ) : (
          <Formik
            initialValues={fallDownAlertSettings ? fallDownAlertSettings : INITIAL_VALUES}
            validationSchema={Yup.object().shape({
              fallDownAlert: Yup.object()
                .shape({
                  enable: Yup.boolean(),
                  always_on: Yup.boolean(),
                  dial: Yup.boolean(),
                  sensitive_level: Yup.number()
                })
                .required()
            })}
            onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
              try {
                setStatus({ success: false });
                setSubmitting(true);

                // Check permission: Redux appUser, partner sessionStorage, Smart Monitor ui_capabilities (canEditDeviceSettings)
                const canModifySettings = resolvePartnerModifySettingsAllowed(appUser);
                if (!canModifySettings) {
                  dispatch(
                    showAppAlert({
                      show: true,
                      alertType: 'error',
                      alertMessage: 'Error: You do not have permission to save these settings.'
                    })
                  );
                  return;
                }
                // console.log(values);

                let payload = { ...values };
                // console.log('payload', payload);

                const tasksRef = doc(db, 'tasks', selectedDevice);
                setDoc(tasksRef, {
                  device_id: selectedDevice,
                  type: 'falldown_alert',
                  user_id: appUser.email ? appUser.email : '-',
                  old_value: fallDownAlertSettings,
                  payload
                })
                  .then((response) => {
                    // console.log('saved tasks!', response);
                    const msg = 'Fall down alert settings saved successfully !';
                    dispatch(showAppAlert({ show: true, alertType: 'success', alertMessage: msg }));
                  })
                  .catch((e) => {
                    const msg = 'Failed to save fall down alert settings!';
                    console.log(msg, e);
                    dispatch(showAppAlert({ show: true, alertType: 'error', alertMessage: msg }));
                  });

                /* await FirestoreDataService.updateDeviceSettingsDocument(selectedDevice, { falldown_alert: fallDownAlertSettings })
                .then(() => {
                  setFallDownAlertSettings(fallDownAlertSettings);

                  FirestoreDataService.setTasks(selectedDevice,'falldown_alert', fallDownAlertSettings).then(()=>{
                    console.log('Saved Tasks!');
                  })
                  const msg = 'Fall Down Alert Settings Saved successfully!';
                  // console.info(msg);
                  dispatch(showAppAlert({ show: true, alertType: 'success', alertMessage: msg }));
                })
                .catch((e) => {
                  const msg = 'Failed to save Fall Down Alert Settings!';
                  console.info(msg, e);
                  dispatch(showAppAlert({ show: true, alertType: 'error', alertMessage: msg }));
                }); */
              } catch (err) {
                dispatch(showAppAlert({ show: true, alertType: 'error', alertMessage: 'Failed to save fall down alert settings' }));
                setStatus({ success: false });
                setErrors({ submit: err.message });
                setSubmitting(false);
              }
            }}
          >
            {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
              <form noValidate onSubmit={handleSubmit}>
                <Box sx={{ mt: 2 }}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    {/* <Typography variant="caption" color="textSecondary">
                      {JSON.stringify(values)}
                    </Typography> */}
                    <Grid item xs={12} justifyContent="space-between" alignItems="center" sx={{ display: 'flex' }}>
                      <Typography variant="h6" color="textSecondary">
                        Sensitivity
                      </Typography>
                      <FormControlLabel
                        name="enable"
                        id="enable"
                        control={<Switch onChange={handleChange} checked={values.enable} />}
                        label="Enable"
                      />
                    </Grid>
                    <Slider
                      disabled={!values.enable}
                      aria-label="sensitivity"
                      name="sensitive_level"
                      id="sensitive_level"
                      marks={marks}
                      onChange={handleChange}
                      value={values.sensitive_level ? values.sensitive_level : 0}
                      valueLabelDisplay="auto"
                      step={1}
                      min={0}
                      max={9}
                    />

                    <Grid item xs={12} sm={12} md={12} lg={12} style={{ paddingTop: 16, paddingBottom: 16 }}>
                      <FormControlLabel
                        disabled={!values.enable}
                        name="always_on"
                        id="always_on"
                        control={<Checkbox onChange={handleChange} checked={values.always_on} />}
                        label="Always On"
                      />
                      <FormControlLabel
                        disabled={!values.enable}
                        name="dial"
                        id="dial"
                        control={<Checkbox onChange={handleChange} checked={values.dial} />}
                        label="Recieve Call"
                      />
                      <Button disableElevation style={{ marginLeft: 16, float: 'right' }} type="submit" variant="contained" color="primary">
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
                {/* <Divider sx={{ mt: 1, mb: 1, borderStyle: 'dashed' }} /> */}
              </form>
            )}
          </Formik>
        )}
      </MainCard>
      <OfflineDialog isOpen={isDialogOpen} handleClose={handleDialogClose}></OfflineDialog>
    </Grid>
  );
};

export default FallDownAlertSettingsPage;
